var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.4347 32.6219H65.5681L77.7804 43.3161H73.7226L52.1679 24.4409V19.2544H58.8413L58.8419 13.9074H52.1685C52.1685 13.1721 51.5679 12.5706 50.8338 12.5706C50.0997 12.5706 49.4991 13.1721 49.4991 13.9074V24.4409L27.9444 43.3161H23.8866L36.0989 32.6219H23.2328L13.6899 43.3161H16.1323V87.4294H44.1607V71.3882H57.5075V87.4294H85.5358V43.3161H87.9782L78.4347 32.6219ZM78.862 58.0205V63.3676H73.5232V58.0205H78.862ZM78.862 68.7147V74.0617H73.5232V68.7147H78.862ZM58.8417 47.3264V52.6735H53.503V47.3264H58.8417ZM28.144 58.0205V63.3676H22.8053V58.0205H28.144ZM28.144 68.7147V74.0617H22.8053V68.7147H28.144ZM32.1481 82.0823V43.3161H34.8174V82.0823H32.1481ZM48.1642 63.3676H42.8255V58.0205H48.1642V63.3676ZM48.1642 52.6735H42.8255V47.3264H48.1642V52.6735ZM53.503 63.3676V58.0205H58.8417V63.3676H53.503ZM66.8498 82.0823V43.3161H69.5192V82.0823H66.8498Z",
    fill: "#1E9AD6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.b7c36ed92379dadaf0cc5d1f98aa6dba.svg";
export { ForwardRef as ReactComponent };